export default __webpack_public_path__ + "2eb0042badd920c059bbd1fff3142df1.png";